export const weekOptions: { weekStartsOn: 1 } = { weekStartsOn: 1 };
